import router from '@/router'
import { allowOnlyWithCompletedJourney } from '@/router/routerGuards'

router.addRoute({
  path: '/deal/:opportunityApplicationId',
  name: 'deal-details',
  component: () => import('@product/components/OpportunityView.vue'),
  meta: {
    permissions: {
      roles: ['user'],
      redirectTo: {
        name: 'login'
      }
    },
    disablePageViewTracking: true
  },
  beforeEnter: allowOnlyWithCompletedJourney()
})

export default {
  path: 'deals',
  name: 'funding-deals',
  component: () => import('./deals.vue'),
  meta: {
    permissions: {
      roles: ['user'],
      redirectTo: {
        name: 'login'
      }
    }
  },
  beforeEnter: allowOnlyWithCompletedJourney()
}
